module.exports = __webpack_public_path__ + "img/layout_bottom_icon.9b6bf1c0.svg";